<template>
      <!-- :style="{backgroundColor: isSingleService? '' : bgColor}" -->
    <header
      v-if="$route.name != 'step-2'"
      class="main-header"
      :style="{
        backgroundColor: isSingleService ? '' : bgColor,
      }"
      :class="{ 
        'fullscreen' : $route.name === 'home',
        'header-contact' : isContacts }">

      <router-link 
        :to="{ name: 'home' }">

        <Logo
          :isDark="getHeroInfo('is-dark')" />

      </router-link> 
      <Hero 
        v-if="!isSingleService && !isContacts && !isThankYouPage && !isFunnel && !isError"
        :title="getHeroInfo('title')" 
        :text="getHeroInfo('text')"
        :text1="getHeroInfo('text1')"
        :text2="getHeroInfo('text2')"
        :displayInput="getHeroInfo('display-input')"
        :isDark="getHeroInfo('is-dark')"/>

      <nav
        :class="{ 'is-dark' : getHeroInfo('is-dark') }">
        <router-link 
          :to="{ name: 'home' }">
            
            {{ $t('menu.items.home.text') }}
        </router-link>
        <router-link 
          :to="{ name: 'about' }">
            
            {{ $t('menu.items.about.text') }}
        </router-link>
        <router-link 
          :to="{ name: 'services-archives' }">
            
            {{ $t('menu.items.services.text') }}
        </router-link>
        <router-link 
          :to="{ name: 'contacts' }">
            
            {{ $t('menu.items.contacts.text') }}
        </router-link>

        <LangSelect />

      </nav>

    </header>
</template>

<script>
import Logo from '@/components/Logo.vue';

import Hero from '@/partials/Hero.vue'
import LangSelect from '@/components/LangSelect.vue';

export default {
  name: "main-header",
  components: {
    Logo,
    Hero,
    LangSelect
  },
  computed: {
    isSingleService: function() {
      return this.$route.name === 'service-details';
    },
    isContacts: function() {
      return this.$route.name === 'contacts';
    },
    isThankYouPage: function() {
      return this.$route.name === 'thank-you';
    },
    isFunnel: function() {
      return this.$route.name && this.$route.name.includes('step-');
    },
    isError: function() {
      return this.$route.name === 'error';
    },
    bgColor: function() {
      switch (this.$route.name) {
        case 'home':
          return '#FBFBFB'
        case 'about':
          return '#409DAE'
        case 'services-archives':
          return '#409DAE'
        case 'thank-you':
          return '#00C781'
        case 'contacts':
          return ''
        case 'step-1':
          return '#409DAE'
        case 'step-2':
          return '#409DAE'
        case 'error':
          return '#CFDBDE'
      
        default:
          break;
      }
      return true;
    },
  },
  methods: {
    getHeroInfo: function(which) {
      switch (this.$route.name) {
        case 'home':
          if(which === 'title') {
          return this.$i18n.t("info.tagline")
          } else if(which === 'text') {
            return this.$i18n.t("components.hero.home.text")
          } else if(which === 'display-input') {
            return true
          } else if(which === 'text1') {
            return this.$i18n.t("components.hero.home.text1")
          }else if(which === 'text2') {
            return this.$i18n.t("components.hero.home.text2")
          } else if(which === 'is-dark') {
            return false
          }
        break;

        case 'about':
          if(which === 'title') {
            return this.$i18n.t("components.hero.about.title")
          } else if(which === 'text') {
            return this.$i18n.t("components.hero.about.text")
          } else if(which === 'display-input') {
            return false
          } else if(which === 'text1') {
            return this.$i18n.t("components.hero.about.text1")
          } else if(which === 'text2') {
            return this.$i18n.t("components.hero.about.text2")
          } else if(which === 'is-dark') {
            return true
          }
        break;

        case 'services-archives':
          if(which === 'title') {
            return this.$i18n.t("components.hero.services.title")
          } else if(which === 'text') {
            return this.$i18n.t("components.hero.services.text")
          } else if(which === 'display-input') {
            return false
          } else if(which === 'text1') {
            return this.$i18n.t("components.hero.services.text1")
          } else if(which === 'text2') {
            return this.$i18n.t("components.hero.services.text2")
          }  else if(which === 'is-dark') {
            return true
          }
        break;

        case 'step-1':
          if(which === 'is-dark') {
            return true
          }
        break;

        case 'step-2':
          if(which === 'is-dark') {
            return true
          }
        break;

        case 'thank-you':
          if(which === 'is-dark') {
            return true
          }
        break;

        case 'contacts':
          if(which === 'title') {
            return this.$i18n.t("components.hero.contacts.title")
          } else if(which === 'text') {
            return this.$i18n.t("components.hero.contacts.text")
          } else if(which === 'display-input') {
            return false
          } else if(which === 'is-dark') {
            return false
          }
        break;


        default:
          break;
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import '../styles/_mixins.scss';

header {

  @include respond-to(desktop) {
    @include grid(12);

    > a {
      grid-column: 2 /span 2;
    }
  }

  &.fullscreen {
    border-bottom: 1px solid #CCC;
  }

  nav {
    @include flex-container;
    justify-content: space-around;
    color: map-get($colors--grays, '6');
    padding: $default_vmin;
    
    @include respond-to(tablet) {
      padding: $small_vmin $large_vmin;
    }

    @include respond-to(desktop) {
      grid-column: 7 / span 5;
      grid-row-start: 1;
      padding: 0;
    }

    @include respond-to(tv) {
      grid-column: 8 / span 4;
    }

    :last-child {
      font-weight: 600;
      text-transform: uppercase;
    }

    &.is-dark {
      margin-top: 10vmin;
      color: white;
      background: rgba(0,0,0,0.1);

      @include respond-to(desktop) {
        background: transparent;
        margin-top: 0;
      }
    }
  }

  article {
    @include grid--fullscreen;
    grid-row-start: 2;

    @include respond-to(desktop) {
      min-height: 18vh;

      &.home {
        @include grid-container;
        min-height: 45vh;
      }
    }

    @include respond-to(tv) {
      min-height: 30vh;
    }
  }
}
</style>


